module.exports = __webpack_public_path__ + "static/media/landingCollaborator4.1cc75dba.jpg";